import {Group, Progress, Text} from '@mantine/core';

/**
 * Completion meter — progress bar plus a `completed/total` count, for
 * "how far through is this" cells in tables and detail panels. Renders a
 * placeholder instead of a zero-width bar when there is nothing to count.
 * @registry Progress bar with completed/total count label and empty-state fallback.
 */
export interface CompletionProgressProps {
  completed: number;
  total: number;
  width?: number;
  emptyLabel?: string;
}

export const CompletionProgress = ({
  completed,
  total,
  width = 100,
  emptyLabel = '—',
}: CompletionProgressProps) => {
  if (total <= 0) return <>{emptyLabel}</>;

  const isComplete = completed >= total;

  return (
    <Group gap="xs" wrap="nowrap">
      <Progress
        value={Math.min(100, Math.max(0, (completed / total) * 100))}
        w={width}
        size="sm"
        color={isComplete ? 'green.8' : undefined}
        aria-label={`${completed} of ${total} complete`}
      />
      <Text size="xs" c="dimmed">
        {completed}/{total}
      </Text>
    </Group>
  );
};
